import Swiper from "swiper";

var swiper = new Swiper(".history-items", {
  loop: false,
  preloadImages: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
